import dayjs from '../dayJs'

export const formatDate = (date) => {
  return dayjs(date).format('MMMM YYYY')
}
